import type { SerializableObject } from '@clientos/types';

/**
 * Environment Variable Context Not Found Error
 * Thrown when requesting a non-existent context
 */
export class EnvironmentVariableContextNotFoundError extends Error {
  public readonly context: string;

  constructor(context: string) {
    super(`Environment variable context '${context}' not found`);
    this.name = 'EnvironmentVariableContextNotFoundError';
    this.context = context;
  }
}
